module.exports = __webpack_public_path__ + "static/media/eCLoud.8ce8300e.webp";